export const RECAPTCHA = {
  tokenKey: 'g-recaptcha-response',
  versionKey: 'g-recaptcha-version',
}

export enum RECAPTCHA_VERSION {
  v2 = 'v2',
  v3 = 'v3',
}
